var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavRMiviviendaActive = function SvgNavRMiviviendaActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_r_mivivienda_active_svg__Capa_2",
    viewBox: "0 0 34 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_r_mivivienda_active_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.45 32.6.04-6.64h0c1.11-4.77 7.91-4.77 9.02 0h0l.04 6.64",
    fill: "none",
    stroke: "#19d3c5",
    strokeLinecap: "round",
    strokeWidth: "1.5px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.17 12.6v18.05c0 1.44-1.16 2.6-2.6 2.6H6.44c-1.44 0-2.6-1.16-2.6-2.6V12.6m29.42 3.01L22.12 4.39C19.71 1.97 18.51.75 17.01.75s-2.7 1.21-5.11 3.64L.75 15.61",
    fill: "none",
    stroke: "#19d3c5",
    strokeLinecap: "round",
    strokeWidth: "1.5px"
  }))));
};
export default SvgNavRMiviviendaActive;